import ResourceModule from './ResourceModule'

export default ResourceModule
